import React from 'react';
import ClockIcon from '@atlaskit/icon/core/clock';
import DateField from '@atlassian/jira-issue-create-commons/src/ui/date-field/index.tsx';
import { DATE_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { DateFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { dateFieldWriter } from '../writers/index.tsx';

const DateCustomFieldTypeComponent = (props: ProvidedFieldProps) => <DateField {...props} />;

export const DateCustomFieldTypeConfig: FieldTypeConfig<string> = {
	icon: ClockIcon,
	type: DATE_CF_TYPE,
	Component: DateCustomFieldTypeComponent,
	placeholder: <DateFieldPlaceholder />,
	writer: dateFieldWriter,
};
